import HistoryPageContextProvider from './HistoryPageContextProvider';

export default HistoryPageContextProvider;
